import { generateMul3x1 } from '../generators/math/mul3x1';
import { runGenericMathKpLesson } from './_runner';
import type { LearnDoneCallback } from '../app';

export function runMathMul3x1Lesson(container: HTMLElement, onDone: LearnDoneCallback): void {
  runGenericMathKpLesson(container, {
    subject: 'math',
    kpId: 'math.mul.3x1',
    generator: generateMul3x1,
  }, onDone);
}
